import React from "react"
import PropTypes from "prop-types"

import { Box, FormGroup } from "@material-ui/core"
import { Field, propTypes, reduxForm } from "redux-form"
import _ from "lodash"
import MenuItem from "@material-ui/core/MenuItem"
import { injectIntl } from "react-intl"
import useAppStyle from "../../../styles/appStyle"
import { ButtonClear, ButtonSubmit } from "../../../component/buttons"
import FieldTextarea from "../../../component/forms/FieldTextarea"
import useSmartFormat from "../../../i18n/useSmartFormat"
import SelectInput from "../../../component/forms/SelectInput"
import { words } from "../../../i18n/lstrings"
import messages from "./userProfileMessage"
import { NORMAL, STAFF, TECHNICAL } from "../../../commons/userTypes"

const USER_PROFILE = {
  staff: {
    value: STAFF,
    message: messages.staff
  },
  normal: {
    value: NORMAL,
    message: messages.normal
  },
  technical: {
    value: TECHNICAL,
    message: messages.technical
  }
}

function UserProfileForm(props) {
  const classes = useAppStyle()
  const format = useSmartFormat()
  const { handleSubmit, handleSave } = props
  const { pristine, submitting, reset } = props

  return (
    <form onSubmit={handleSubmit(handleSave)}>
      <FormGroup>
        <Field
          component={SelectInput}
          id="superRole"
          label={format(messages.role)}
          name="superRole"
        >
          {_.map(Object.values(USER_PROFILE), (profile) => {
            const bundleKey = profile.message
            return (
              <MenuItem key={bundleKey.id} value={profile.value}>
                {format(bundleKey)}
              </MenuItem>
            )
          })}
        </Field>

        <Field
          component={FieldTextarea}
          id="label"
          label={format(messages.userProfileLabel)}
          name="label"
          type="text"
        />
      </FormGroup>

      <Box className={`${classes.formButton}`}>
        <ButtonClear disabled={pristine || submitting} onClick={reset} />
        <ButtonSubmit disabled={submitting} />
      </Box>
    </form>
  )
}

function validate(values, props) {
  const { formatMessage: format } = props.intl
  const errors = {}
  if (!values.superRole) {
    errors.superRole = format(words.required)
  }

  if (!values.label) {
    errors.label = format(words.required)
  }

  return errors
}

UserProfileForm.formName = "UserProfileForm"

UserProfileForm.propTypes = {
  ...propTypes,
  intl: PropTypes.any.isRequired
}

export default injectIntl(
  reduxForm({
    form: UserProfileForm.formName,
    validate
  })(UserProfileForm)
)
